import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Cancel01Icon, Copy01Icon, CheckmarkCircle01Icon, Alert02Icon } from '@hugeicons/core-free-icons';

function ApiKeyModal({ isOpen, onClose, apiKey }) {

    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => {}}>
                <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black/30" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-150" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-700">
                                    <Dialog.Title className="text-base font-semibold text-gray-900 dark:text-gray-50">
                                        API Key Created
                                    </Dialog.Title>
                                    <button type="button" onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
                                        <HugeiconsIcon icon={Cancel01Icon} size={16} />
                                    </button>
                                </div>

                                <div className="px-6 py-5 space-y-4">
                                    <div className="flex items-start gap-2.5 p-3 bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 rounded-lg">
                                        <HugeiconsIcon icon={Alert02Icon} size={16} className="text-amber-600 dark:text-amber-400 mt-0.5 shrink-0" />
                                        <p className="text-xs text-amber-700 dark:text-amber-400">
                                            This API key will only be shown once. Copy it now and store it securely. It cannot be retrieved later.
                                        </p>
                                    </div>

                                    <div className="relative">
                                        <div className="bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
                                            <code className="text-xs font-mono text-gray-800 dark:text-gray-200 break-all leading-relaxed">
                                                {apiKey}
                                            </code>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={copyToClipboard}
                                            className="absolute top-2 right-2 p-1.5 rounded-md bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                                            title="Copy to clipboard"
                                        >
                                            <HugeiconsIcon icon={copied ? CheckmarkCircle01Icon : Copy01Icon} size={14} className={copied ? "text-emerald-500" : "text-gray-400"} />
                                        </button>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={onClose}
                                        className="w-full px-4 py-2.5 text-sm font-medium text-white bg-[#1e3a6e] rounded-lg hover:bg-[#264d91] transition-colors"
                                    >
                                        I've copied the key
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default ApiKeyModal;
